export const frontendDomain = 'curl2url.com'
export const backendDomain = 'backend.curl2url.com'
export const protocol = 'https'
